import { Injectable } from "@angular/core";
import { QueryEntity } from "@datorama/akita";
import { AnagraficaServiziState, AnagraficaServiziStore } from "./anagraficaServizi.store";

@Injectable({
  providedIn: 'root'
})
export class AnagraficaServiziQuery extends QueryEntity<AnagraficaServiziState> {
  constructor(protected store: AnagraficaServiziStore) {
    super(store);
  }
}
